import get from 'lodash/get';
import * as types from './constants';

const mortgageDetailsInitialState = {
  startDate: '',
  endDate: '',
  mortgageAmount: null,
  mortgageTypeId: null,
  contractNumber: null,
  bankSignatoryId: null,
  valuationCompanyLicenseNumber: '',
  valuatorProfessionId: null,
};
const defaultState = {
  loading: false,
  error: null,
  validationMessage: null,
  activeStep: 0,
  application: {},
  applicationInitalData: {},
  documents: [],
  property: {},
  Banklists: [],
  representativeDetails: [],
  applicationId: null,
  applicationType: '',
  propertyDocuments: null,
  contractDetails: {},
  /** --------------- MORTGAGE BANK MAKER --------------- */
  mortgageDetails: mortgageDetailsInitialState,
  mortgageTypes: [],
  bankSignatories: [],
  valuationCompanies: [],
  valuators: [],
  dropDownsErrors: [],
};

export default function mortgageReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.NHL_MORTGAGE_OPERATION_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.NHL_MORTGAGE_OPERATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.NHL_MORTGAGE_OPERATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload || null,
      };
    case types.FETCH_APPLICATION_NHL_MORTGAGE:
      return {
        ...state,
        loading: true,
        application: null,
        error: null,
      };
    case types.FETCH_APPLICATION_NHL_MORTGAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        Banklists: get(action.payload, 'Banklists', []),
        representativeDetails: get(action.payload, 'representativeDetails', []),
        documents: get(action.payload, 'documents', []),
        property: get(action.payload, 'property', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
      };
    case types.FETCH_APPLICATION_NHL_MORTGAGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.INITIATE_NHL_MORTGAGE_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.INITIATE_NHL_MORTGAGE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.INITIATE_NHL_MORTGAGE_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CHANGE_NHL_MORTGAGE_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };
    case types.UPLOAD_NHL_MORTGAGE_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_NHL_MORTGAGE_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.UPLOAD_NHL_MORTGAGE_DOCUMENT_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.DOWNLOAD_DOCUMENT_NHL_MORTGAGE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_NHL_MORTGAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_NHL_MORTGAGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SHOW_VALIDATION_MESSAGE:
      return {
        ...state,
        validationMessage: action.payload,
      };
    case types.CLEAR_VALIDATION_MESSAGE:
      return {
        ...state,
        validationMessage: null,
      };
    case types.SAVE_APPLICATION_NHL_MORTGAGE:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.SAVE_APPLICATION_NHL_MORTGAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        // application: get(action.payload, 'application', {}),
        error: null,
      };

    case types.SAVE_APPLICATION_NHL_MORTGAGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.NHL_MORTGAGE_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.NHL_MORTGAGE_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.NHL_MORTGAGE_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SET_CONTRACT_DETAILS:
      return {
        ...state,
        contractDetails: { ...state.contractDetails, [action.payload.key]: action.payload.value },
      };
    case types.CHECKOUT_NHL_MORTGAGE_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.CHECKOUT_NHL_MORTGAGE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeStep: 0,
      };
    case types.CHECKOUT_NHL_MORTGAGE_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    /** --------------- MORTGAGE BANK MAKER --------------- */
    case types.SET_NHL_MORTGAGE_BANK_MAKER_DETAILS:
      return {
        ...state,
        mortgageDetails: { ...state.mortgageDetails, [action.payload.key]: action.payload.value },
      };

    case types.FETCH_NHL_MORTGAGE_BANK_MAKER_APPLICATION:
      return {
        ...state,
        loading: true,
        application: null,
        error: null,
      };
    case types.FETCH_NHL_MORTGAGE_BANK_MAKER_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        documents: get(action.payload, 'documents', []),
        property: get(action.payload, 'property', {}),
        mortgageDetails: get(action.payload, 'mortgageDetails', mortgageDetailsInitialState),
        mortgageTypes: get(action.payload, 'mortgageTypes', []),
        bankSignatories: get(action.payload, 'bankSignatories', []),
        valuationCompanies: get(action.payload, 'valuationCompanies', []),
        contractDetails: get(action.payload, 'contractDetails', {}),
        dropDownsErrors: get(action.payload, 'dropDownsErrors', []),
      };
    case types.FETCH_NHL_MORTGAGE_BANK_MAKER_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_NHL_MORTGAGE_VALUATORS:
      return {
        ...state,
        loading: true,
        error: null,
        valuators: [],
      };
    case types.FETCH_NHL_MORTGAGE_VALUATORS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        valuators: get(action.payload, 'valuators', []),
      };
    case types.FETCH_NHL_MORTGAGE_VALUATORS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        valuators: [],
      };

    case types.CLEAR_NHL_MORTGAGE_VALUATORS:
      return {
        ...state,
        valuators: [],
        mortgageDetails: { ...state.mortgageDetails, valuatorProfessionId: null },
      };

    case types.SAVE_NHL_MORTGAGE_BANK_MAKER_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.SAVE_NHL_MORTGAGE_BANK_MAKER_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        documents: get(action.payload, 'documents', {}),
        property: get(action.payload, 'property', {}),
        activeStep: get(action.payload, 'step'),
        error: null,
      };

    case types.SAVE_NHL_MORTGAGE_BANK_MAKER_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.NHL_MORTGAGE_CLEAR_DATA:
      return {
        ...defaultState,
      };
    case types.NHL_MORTGAGE_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
}
